<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  import { mapState } from 'vuex'
  import api from '@/api'
  import { isMobile } from 'mobile-device-detect'
  import EventPreview from '@/components/layout/EventPreview'

  export default {
    name: 'TemplateSlider',
    components: {
      EventPreview,
    },
    props: { article: Object },
    data() {
      return {
        hoverLike: false,
        comments: {
          data: {},
        },
        likes: {
          data: {},
        },
      }
    },
    computed: {
      ...mapState('auth', ['settings']),
      getArticleImage() {
        const imagePlaceholder = this.customerConfig.images.imagePlaceholder
        const article = this.article

        if (article.images && article.images.title) {
          return article.images.title.link
        } else if (article.attachments[0] && article.attachments[0].link) {
          return article.attachments[0].link
        } else {
          return imagePlaceholder
        }
      },
    },
    created() {
      if (!Object.prototype.hasOwnProperty.call(this.article, 'likes_allowed') || this.article.likes_allowed) {
        this.fetchLikes()
      }
      if (this.article.comments_allowed) {
        this.fetchComments()
      }
    },
    methods: {
      clampLines(type) {
        const lineConfig = {
          title: isMobile ? 2 : 1,
          teaser: this.exceptionalCustomers() ? 2 : isMobile ? 2 : 7,
        }
        return lineConfig[type] || 2
      },
      imageHeight() {
        return this.exceptionalCustomers() ? (this.isCustomer('motelone') ? '372' : '340') : 'auto'
      },
      async fetchComments() {
        api.items.getItems('comments', { type: 'news', id: this.article.id })
          .then(({ data }) => {
            this.comments.data = data
          })
      },
      async fetchLikes() {
        api.items.getItems('likes', { type: 'news', id: this.article.id })
          .then(({ data }) => {
            this.likes.data = data
          })
      },
      onLike(val) {
        api.items.editItem('likes', { type: 'news', id: this.article.id, like: val }).then(({ data }) => {
          this.likes.data = data
        })
      },
      onCommentClick() {
        if (!this.exceptionalCustomers()) {
          this.$router.push({
            name: 'page',
            params: { id: this.article.id },
            hash: '#comments',
          })
        }
      },
    },
  }
</script>
